import React, { forwardRef } from 'react';
import { HBTextAreaProps } from './HBTextArea.types';

const TextAreaBase = forwardRef<HTMLTextAreaElement, HBTextAreaProps>(
    (props, ref) => {
        const {
            customTheme,
            size,
            error,
            children,
            isNewHBMode,
            resizable,
            tags,
            onTagRemove,
            ...baseProps
        } = props;
        return <textarea autoComplete="off" {...baseProps} ref={ref} />;
    }
);

export default TextAreaBase;
